export const CONTACTS = "contacts" as const

export namespace CONTACT_TYPE {
    export const PERSON = "persons" as const
    export const COMPANY = "companies" as const
    export const SUPPLIER = "suppliers" as const
}




// WEBPACK FOOTER //
// ./src/utils/contacts/constants.ts